export const CPC_REFERRER_COOKIE_KEY = 'external_cpc';
export const CPC_REFERRER_SEARCH_PARAM_KEY = 'from';
